module.exports = __webpack_public_path__ + "img/unsel_pc.3ab7806f.svg";